export const translations = {
    es: {
        // Login
        portalTitle:        'Portal de Clientes',
        portalSubtitle:     'Accede para ver el estado de tus reparaciones',
        emailLabel:         'Correo electrónico',
        emailPlaceholder:   'tu@correo.com',
        passwordLabel:      'Contraseña',
        errorNoClient:      'No se encontró ningún cliente asociado a este correo.',
        errorCredentials:   'Correo o contraseña incorrectos.',
        signingIn:          'Accediendo...',
        signIn:             'Acceder',

        // Loading
        loadingPortal:      'Cargando portal...',

        // Lang toggle
        switchLang:         'Switch to English',

        // Nav
        repairs:            'Reparaciones',
        invoices:           'Facturas',
        signOut:            'Cerrar sesión',

        // Dashboard - repairs
        newRepair:          'Nueva reparación',
        itemsPerPage:       'Filtrar por página',
        searchPlaceholder:  'Buscar por referencia, IMEI, modelo, avería...',
        inProgress:         'Mis reparaciones',
        noRepairs:          'No hay reparaciones registradas',
        addFirstRepair:     'Añadir primera reparación',

        // Dashboard - new repair form
        formTitle:          'Nueva reparación',
        fieldDevice:        'Dispositivo',
        fieldDevicePh:      'Ej: iPhone 14, Samsung Galaxy S23...',
        fieldFault:         'Avería',
        fieldFaultPh:       'Descripción breve del problema',
        fieldImei:          'IMEI / Nº de serie',
        fieldOptional:      'Opcional',
        fieldUnlock:        'Código desbloqueo',
        fieldRefClient:     'Tu referencia interna',
        fieldNotes:         'Observaciones',
        fieldNotesPh:       'Ej: Incluye cargador, tapa rota...',
        errorRequired:      'El dispositivo y la descripción son obligatorios.',
        errorSaving:        'Error al registrar el dispositivo. Inténtalo de nuevo.',
        repairRegistered:   'Reparación registrada',
        cancel:             'Cancelar',
        registering:        'Registrando...',
        register:           'Registrar',

        // Dashboard - invoices
        noInvoices:         'No hay facturas disponibles',
        downloadInvoice:    'Descargar factura',
        invoice:            'Factura',
        proforma:           'Proforma',

        // Task card
        deviceFallback:     'Dispositivo',
        unknownState:       'Desconocido',
        acceptQuote:        'Aceptar presupuesto',
        generating:         'Generando...',
        report:             'Informe',
        refClient:          'Ref. cliente:',
        exitDate:           'Fecha salida:',
        acceptedOn:         'Presupuesto aceptado:',
        ivaIncluded:        '(IVA incl.)',
        ivaExcluded:        '(+ IVA)',
        collected:          'Recogido ✓',

        // Sign modal
        signTitle:          'Firmar presupuesto',
        signHint:           'Firma en el recuadro',
        signLegal:          (budget, device, description) =>
            `Al firmar acepta el presupuesto de ${budget} € para la reparación de su ${device}${description ? ` (${description})` : ''}.`,
        clear:              'Borrar',
        saving:             'Guardando...',
        confirmSign:        'Confirmar firma',

        // Invoice modal
        loading:            'Cargando...',
        total:              'TOTAL',
        viewPDF:            'Ver PDF',
        download:           'Descargar',

        // States
        states: {
            0: 'En diagnóstico',
            1: 'Enviado al exterior',
            2: 'Reparado',
            3: 'Esperando repuesto',
            4: 'Sin reparar',
            5: 'Reparando',
            6: 'Pendiente confirmación',
            7: 'En tránsito',
        },
    },

    en: {
        // Login
        portalTitle:        'Client Portal',
        portalSubtitle:     'Log in to check the status of your repairs',
        emailLabel:         'Email address',
        emailPlaceholder:   'you@email.com',
        passwordLabel:      'Password',
        errorNoClient:      'No client found for this email address.',
        errorCredentials:   'Incorrect email or password.',
        signingIn:          'Signing in...',
        signIn:             'Sign in',

        // Loading
        loadingPortal:      'Loading portal...',

        // Lang toggle
        switchLang:         'Cambiar a español',

        // Nav
        repairs:            'Repairs',
        invoices:           'Invoices',
        signOut:            'Sign out',

        // Dashboard - repairs
        newRepair:          'New repair',
        itemsPerPage:       'Items per page',
        searchPlaceholder:  'Search by reference, IMEI, model, fault...',
        inProgress:         'My repairs',
        noRepairs:          'No repairs registered',
        addFirstRepair:     'Add first repair',

        // Dashboard - new repair form
        formTitle:          'New repair',
        fieldDevice:        'Device',
        fieldDevicePh:      'E.g.: iPhone 14, Samsung Galaxy S23...',
        fieldFault:         'Fault',
        fieldFaultPh:       'Brief description of the problem',
        fieldImei:          'IMEI / Serial number',
        fieldOptional:      'Optional',
        fieldUnlock:        'Unlock code',
        fieldRefClient:     'Your internal reference',
        fieldNotes:         'Notes',
        fieldNotesPh:       'E.g.: Includes charger, broken cover...',
        errorRequired:      'Device and fault description are required.',
        errorSaving:        'Error registering device. Please try again.',
        repairRegistered:   'Repair registered',
        cancel:             'Cancel',
        registering:        'Registering...',
        register:           'Register',

        // Dashboard - invoices
        noInvoices:         'No invoices available',
        downloadInvoice:    'Download invoice',
        invoice:            'Invoice',
        proforma:           'Proforma',

        // Task card
        deviceFallback:     'Device',
        unknownState:       'Unknown',
        acceptQuote:        'Accept quote',
        generating:         'Generating...',
        report:             'Report',
        refClient:          'Client ref.:',
        exitDate:           'Completion date:',
        acceptedOn:         'Quote accepted:',
        ivaIncluded:        '(VAT incl.)',
        ivaExcluded:        '(+ VAT)',
        collected:          'Collected ✓',

        // Sign modal
        signTitle:          'Sign quote',
        signHint:           'Sign in the box',
        signLegal:          (budget, device, description) =>
            `By signing you accept the quote of ${budget} € for the repair of your ${device}${description ? ` (${description})` : ''}.`,
        clear:              'Clear',
        saving:             'Saving...',
        confirmSign:        'Confirm signature',

        // Invoice modal
        loading:            'Loading...',
        total:              'TOTAL',
        viewPDF:            'View PDF',
        download:           'Download',

        // States
        states: {
            0: 'In diagnosis',
            1: 'Sent for external repair',
            2: 'Repaired',
            3: 'Waiting for parts',
            4: 'Not repaired',
            5: 'Repairing',
            6: 'Pending confirmation',
            7: 'In transit',
        },
    },
}
